export default "__VITE_ASSET__CcYu5_ri__"